import { SharedModule } from '../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersoHoldingsComponent } from '../../../components/search/verso-holdings/verso-holdings.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule],
  declarations: [VersoHoldingsComponent],
  exports: [VersoHoldingsComponent],
})
export class SearchSharedModule {}
